import { tsValidateBoolean } from '@nu-art/ts-common';
export const Validator_AdvisorWizardConfig = {
    isHpi: tsValidateBoolean(false),
    loadFindings: tsValidateBoolean(false),
    onlyLoadFindingsFromRTOrder: tsValidateBoolean(false),
};
//# sourceMappingURL=validator.js.map